import React, { useContext, useEffect, useState } from 'react';
import { DndProvider, DropTargetMonitor, useDrag, useDrop } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { useNavigate, useOutletContext } from 'react-router-dom';
import styled from 'styled-components';
import ProductController, {
  OptionGroupItemType,
  OptionGroupType,
} from '../../../controller/ProductController';
import { useToast } from '../../../controller/ToastController';
import { AuthContext } from '../../../navigation/AuthProvider';
import { CurrentStoreContext } from '../../../controller/StoreController';

const OptionIndex = () => {
  const navigate = useNavigate();
  const showToast = useToast();
  const [optionList, setOptionList] = useState<OptionGroupType[]>([]);
  const { currentStore } = useOutletContext<CurrentStoreContext>();
  const [isOpen, setIsOpen] = useState<boolean[]>([]);

  const navigateOptionDetails = (option_index?: number) => {
    if (option_index !== undefined) {
      navigate(`/product/option/edit`, { state: { optionInfo: optionList[option_index] } });
    } else navigate(`/product/option/edit`);
  };

  // API 호출
  const getOptions = async () => {
    try {
      const oRes = await ProductController.getAllOptionGroup(currentStore.value);

      if (oRes && oRes.data) {
        const oResponse = oRes.data;
        console.log('getOptions', oResponse);
        if (oResponse.data) {
          setOptionList([...oResponse.data]);
          let openTemp = new Array(oResponse.data.length).fill(false);
          openTemp[0] = true;
          setIsOpen([...openTemp]);
        }
      }
    } catch (err) {
      console.log('err---->', err);
    }
  };
  const changeIndexOptionData = async () => {
    try {
      const oRes = await ProductController.editOptionGroupIdOrder(currentStore.value, optionList);
      if (oRes && oRes.data) {
        const oResponse = oRes.data;
        console.log('editOptionGroupIdOrder', oResponse);
        if (oResponse.data && oResponse.ok) {
          showToast('옵션의 순서를 변경했어요');
        }
      }
    } catch (err) {
      console.log('err---->', err);
    }
  };

  useEffect(() => {
    getOptions();
  }, [currentStore]);

  const moveItem = (fromIndex: number, toIndex: number) => {
    if (toIndex < 1) toIndex = 0;
    else if (toIndex > optionList.length - 1) toIndex = optionList.length;
    const newItems = [...optionList];
    const [movedItem] = newItems.splice(fromIndex, 1);
    newItems.splice(toIndex, 0, movedItem);
    setOptionList(newItems);
    setIsOpen(new Array(optionList.length).fill(false));
  };

  interface DraggableItemProps {
    item: OptionGroupType;
    index: number;
    moveItem: (fromIndex: number, toIndex: number) => void;
  }

  const RenderOptionGroup = ({ item, index, moveItem }: DraggableItemProps) => {
    const [selectedIndex, setSelectedIndex] = useState<number>(index + 1);

    const changeIsOpen = () => {
      const dataTemp = isOpen;
      dataTemp[index] = !dataTemp[index];
      setIsOpen([...dataTemp]);
    };

    const [, drag] = useDrag({
      type: 'ITEM',
      item: { item, index },
    });

    const [, drop] = useDrop({
      accept: 'ITEM',
      hover: (item: { index: number }, monitor: DropTargetMonitor) => {
        if (item.index !== index) {
          moveItem(item.index, index);
          item.index = index;
        }
      },
    });

    const moveMenuItem = (mainIndex: number, fromIndex: number, toIndex: number) => {
      if (toIndex < 1) toIndex = 0;
      else if (toIndex > optionList[mainIndex].option_list.length - 1)
        toIndex = optionList[mainIndex].option_list.length;
      let newMainItems = [...optionList];
      const newItems = [...newMainItems[mainIndex].option_list];
      const [movedItem] = newItems.splice(fromIndex, 1);
      newItems.splice(toIndex, 0, movedItem);
      newMainItems[mainIndex].option_list = newItems;
      setOptionList(newMainItems);
    };

    return (
      <div key={index}>
        <div className={`listItem ${isOpen[index] && 'open'}`}>
          <div className="row gap">
            <div className="row">
              <input
                ref={(node) => drag(drop(node))}
                value={selectedIndex}
                autoFocus={false}
                onChange={(e) => {
                  setSelectedIndex(Number(e.target.value));
                }}
                onBlur={() => {
                  moveItem(index, selectedIndex - 1);
                }}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    moveItem(index, selectedIndex - 1);
                  }
                }}
              />
              {/* <img
                src={`${process.env.PUBLIC_URL}/svg/ic_arrow_up_box.svg`}
                onClick={() => orderUpChange(index)}
                alt="ic"
              />
              <img
                src={`${process.env.PUBLIC_URL}/svg/ic_arrow_down_box.svg`}
                onClick={() => orderDownChange(index)}
                alt="ic"
              /> */}
            </div>
            <h3>{item.name}</h3>
            {item.input_min !== 0 && <h5>필수선택 {item.input_min}개</h5>}
          </div>
          <div className="row gap">
            <img
              src={`${process.env.PUBLIC_URL}/svg/ic_edit.svg`}
              alt="ic"
              onClick={() => navigateOptionDetails(index)}
            />
            {/* <img src={`${process.env.PUBLIC_URL}/svg/ic_trashcan.svg`} alt="ic" /> */}
            <img
              src={`${process.env.PUBLIC_URL}/svg/ic_arrow_${
                isOpen[index] ? 'up' : 'down'
              }_grey.svg`}
              onClick={changeIsOpen}
              width={30}
              height={30}
              alt="ic"
            />
          </div>
        </div>
        {isOpen[index] && (
          <div className="menuList">
            {item.option_list.map((subItem: OptionGroupItemType, subIndex: number) => {
              return (
                <RenderOptionItem
                  key={`${index}_${subIndex}`}
                  mainIndex={index}
                  subItem={subItem}
                  subIndex={subIndex}
                  moveMenuItem={moveMenuItem}
                />
              );
            })}
          </div>
        )}
      </div>
    );
  };

  interface DraggableMenuItemProps {
    subItem: OptionGroupItemType;
    mainIndex: number;
    subIndex: number;
    moveMenuItem: (mainIndex: number, fromIndex: number, toIndex: number) => void;
  }

  const RenderOptionItem = ({
    subItem,
    mainIndex,
    subIndex,
    moveMenuItem,
  }: DraggableMenuItemProps) => {
    const [selectedMenuIndex, setSelectedMenuIndex] = useState<number>(subIndex + 1);

    const [, menuDrag] = useDrag({
      type: 'ITEM',
      item: { mainIndex, subItem, subIndex },
    });

    const [, menuDrop] = useDrop({
      accept: 'ITEM',
      hover: (item: { mainIndex: number; subIndex: number }, monitor: DropTargetMonitor) => {
        if (item.mainIndex === mainIndex && item.subIndex !== subIndex) {
          moveMenuItem(mainIndex, item.subIndex, subIndex);
          item.subIndex = subIndex;
        }
      },
    });

    return (
      <div className="menuItem" key={subIndex}>
        <div className="row">
          <input
            ref={(node) => menuDrag(menuDrop(node))}
            value={selectedMenuIndex}
            autoFocus={false}
            onChange={(e) => {
              setSelectedMenuIndex(Number(e.target.value));
            }}
            onBlur={() => {
              moveMenuItem(mainIndex, subIndex, selectedMenuIndex - 1);
            }}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                moveMenuItem(mainIndex, subIndex, selectedMenuIndex - 1);
              }
            }}
          />
          <div className="column">
            <h4>{subItem.name}</h4>
            <h5>{subItem.price}원</h5>
            {/* <h5>30,000원</h5> */}
          </div>
        </div>
      </div>
    );
  };

  return (
    <Style>
      <div className="contentContainer">
        <button className="addButton" onClick={() => navigateOptionDetails()}>
          <img src={`${process.env.PUBLIC_URL}/svg/ic_plus.svg`} alt="ic" />
          <h4>옵션 추가하기</h4>
        </button>

        <DndProvider backend={HTML5Backend}>
          {optionList.length > 0 ? (
            <div className="categoryList">
              {optionList.map((item: OptionGroupType, index: number) => {
                return (
                  <RenderOptionGroup key={index} item={item} index={index} moveItem={moveItem} />
                );
              })}
            </div>
          ) : (
            <div className="noneWrap">
              <h3>옵션을 등록해주세요</h3>
            </div>
          )}
        </DndProvider>
        <button className={`submitButton`} onClick={changeIndexOptionData}>
          저장
        </button>
      </div>
    </Style>
  );
};

export default OptionIndex;

const Style = styled.div`
  @keyframes expandDown {
    0% {
      height: 0;
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  .addButton {
    width: 100%;
    border: 1px solid #4dd2ae;
    border-radius: 5px;
    padding: 8px 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5%;
    margin-bottom: 10px;

    h4 {
      font-weight: 600;
      color: #4dd2ae;
      white-space: nowrap;
      padding: 0;
    }
  }

  input {
    width: 30px;
    height: 30px;
    padding: 4px;
    font-size: 16px;
    line-height: 20px;
    font-weight: 600;
    text-align: center;
    color: #40977f;
    background: #ecf5f3;
    border: 1px solid #4dd2ae;
    border-radius: 4px;
  }

  .categoryList {
    padding: 10px 0;
    display: flex;
    flex-direction: column;
    gap: 20px;

    .listItem {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 10px 16px 10px 22px;
      background: #ecf5f3;
      border: 1px solid #ecf5f3;
      border-radius: 5px;

      .row {
        gap: 6px;
      }
      .row.gap {
        gap: 14px;
      }
      h3 {
        color: #555555;
        font-weight: 600;
      }
      h5 {
        color: #979797;
        font-weight: 500;
      }
    }
    .listItem.open {
      border-radius: 5px 5px 0 0;
    }

    .menuList {
      display: flex;
      flex-direction: column;
      border: 1px solid #e5e5e5;
      border-top: none;
      border-radius: 0 0 5px 5px;

      .menuItem {
        min-height: 65px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 2px 22px;
        border-bottom: 1px solid #f7f7f7;

        input {
          width: 24px;
          height: 24px;
          padding: 4px;
          font-size: 14px;
          line-height: 16px;
          color: #979797;
          background: #ffffff;
          border: 1px solid #cecece;
        }

        .column {
          gap: 2px;
        }
        h4 {
          color: #555555;
          font-weight: 600;
        }
        h5 {
          color: #555555;
          font-weight: 400;
        }
        .row {
          gap: 20px;

          .imgWrap {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 60px;
            height: 60px;
            border-radius: 5px;
            img {
              width: 100%;
              height: 100%;
              object-fit: contain;
              border-radius: 5px;
            }
          }
        }
      }
    }
  }
`;
